var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427318921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10",
    filter: "url(#filter0_b_4864_316)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#00685E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4903 7.85997C16.4921 8.06598 16.4129 8.26445 16.2698 8.41264L10.3769 14.3055C10.2296 14.4528 10.0298 14.5355 9.82143 14.5355C9.61308 14.5355 9.41327 14.4528 9.26593 14.3055L6.12307 11.1626C5.97995 11.0145 5.90075 10.816 5.90254 10.61C5.90433 10.404 5.98696 10.2069 6.13264 10.0612C6.27832 9.91554 6.47539 9.8329 6.6814 9.83111C6.88741 9.82932 7.08588 9.90852 7.23407 10.0516L9.82143 12.639L15.1588 7.30164C15.307 7.15852 15.5054 7.07932 15.7115 7.08111C15.9175 7.0829 16.1145 7.16554 16.2602 7.31121C16.4059 7.45689 16.4885 7.65396 16.4903 7.85997Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4864_316",
    x: -12.2571,
    y: -12.2571,
    width: 46.5143,
    height: 46.5143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.12857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4864_316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4864_316",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.e4419f80512d09479f6781b1d9058105.svg";
export { ForwardRef as ReactComponent };